import { API_URL } from "../config";


export const Endpoint = {
  public: API_URL + "/public",
  containers: API_URL + "/containers",
  dataStreams: API_URL + "/datastreams",
  search: API_URL + "/public/search",
};
